<template>
  <div
    v-if="isSuccess"
    class="min-h-screen flex flex-col items-center justify-center text-center p-8 fadeIn-0-5s"
    style="min-height: 60vh;"
  >
    <div
      class="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6"
      style="box-shadow: 0 10px 25px rgba(16, 185, 129, 0.2);"
    >
      <CheckCircle :size="48" class="text-green-600" />
    </div>
    <h2 class="text-4xl font-serif font-bold text-gray-900 mb-4">
      Order Confirmed!
    </h2>
    <p class="text-xl text-gray-600 mb-8 max-w-md">
      Thank you, {{ firstName }}. <br />
      We'll have your order ready
      {{
        orderConfig.timing === "asap"
          ? "soon"
          : `on ${orderConfig.scheduledDay || "the scheduled date"}`
      }}.
    </p>
    <button
      @click="handleBackToOrder"
      class="px-8 py-4 bg-primary-600 hover:bg-primary-700 text-white font-bold rounded-2xl shadow-xl hover:shadow-2xl transition-all transform active:scale-95 flex items-center gap-2"
      style="box-shadow: 0 20px 25px rgba(37, 99, 235, 0.2);"
    >
      <ArrowLeft :size="20" />
      Back to Menu
    </button>
  </div>
</template>

<script>
import { ArrowLeft, CheckCircle } from "lucide-vue";

export default {
  name: "CheckoutSuccessState",
  components: {
    ArrowLeft,
    CheckCircle
  },
  props: {
    isSuccess: {
      type: Boolean,
      required: true
    },
    firstName: {
      type: String,
      default: ""
    },
    orderConfig: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleBackToOrder() {
      this.$emit("back-to-order");
    }
  }
};
</script>
